import React, { useState, useEffect } from 'react';

const LinkEditorModal = ({ editor, data, options, onSave, onClose }) => {
  const [href, setHref] = useState(data.component.get('attributes').href || '');
  const [title, setTitle] = useState(data.component.get('attributes').title || '');
  const [content, setContent] = useState((data.component.view.el.innerHTML || ''));
  const [emailAddress, setEmailAddress] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [selectedLinkTypeID, setSelectedLinkTypeID] = useState('custom');
  const [selectedLink, setSelectedLink] = useState('');



  const getHref = () => {
    if (selectedLinkTypeID === 'email') {
      const queryStringParts = [];
      if (emailSubject) {
        queryStringParts.push(`subject=${encodeURIComponent(emailSubject)}`);
      }
      if (emailBody) {
        queryStringParts.push(`body=${encodeURIComponent(emailBody)}`);
      }
      return `mailto:${emailAddress}?${queryStringParts.join('&')}`;
    }
    return href;
  };

  const handleSave = () => {
    const component = data.component;
    
    // Store the old state for undo
    const oldAttributes = {...component.get('attributes')};
    const oldContent = component.get('content');
    
    // Update attributes
    const attributes = component.get('attributes');
    attributes.title = title;
    attributes.href = getHref();
    component.set('attributes', attributes);
    
    // Update content
    component.components(content);
    
    // Add to undo stack
    editor.UndoManager.add({
        component,
        before: {
            attributes: oldAttributes,
            content: oldContent
        },
        after: {
            attributes: {...attributes},
            content: content
        }
    });
    
    onSave();
};
  return (
    <div>
      <div>
        <div style={{ paddingBottom: '10px' }}>
          <div>
            <label htmlFor="selectedLink">URL</label>
          </div>
          <div className="gjs-field gjs-field-text">
            <div className="gjs-input-holder">
              <input
                type="text"
                value={href}
                onChange={e => (setHref(e.target.value))}
                placeholder={`Enter custom URL`}
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div style={{ paddingBottom: '10px' }}>
          <div>
            <label htmlFor="linkContent">Link Text</label>
          </div>
          <div className="gjs-field gjs-field-text">
            <div className="gjs-input-holder">
              <input
                type="text"
                id="linkContent"
                value={content}
                onChange={e => setContent(e.target.value)}
                placeholder="Enter link text content"
              />
            </div>
          </div>
        </div>
        <div style={{ paddingBottom: '10px' }}>
          <div>
            <label htmlFor="linkTitle">Link Title</label>
          </div>
          <div className="gjs-field gjs-field-text">
            <div className="gjs-input-holder">
              <input
                type="text"
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="Enter title (appears as a tooltip on hover)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex gap-2 mt-20px align-items-center justify-content-center">
            <button type="button" class="fs-12 w-50 mt-0 integration-btns integration-btn-grey" onClick={onClose}>Cancel</button>
            <button onClick={handleSave} type="button" class="fs-12 w-50 shadow-none project-blue-btn">Save Changes</button>
      </div>
    </div>
  );
};

export default LinkEditorModal;
